import axios from "axios";
import server from "../service/api";

export const set_query = (dispatch, query) => {
  return dispatch({
    type: "SET_QUERY",
    payload: query,
  });
};

export const set_program = (dispatch, program) => {
  return dispatch({
    type: "SET_PROGRAM",
    payload: program,
  });
};

export const set_center_hub = (dispatch, center) => {
  return dispatch({
    type: "SET_CENTER_HUB",
    payload: center,
  });
};

export const set_institutions = (dispatch, institutions) => {
  return dispatch({
    type: "SET_INSTITUTIONS",
    payload: institutions,
  });
};

export const set_technology = (dispatch, technology) => {
  return dispatch({
    type: "SET_TECHNOLOGY",
    payload: technology,
  });
};

export const set_disease = (dispatch, disease) => {
  return dispatch({
    type: "SET_DISEASE",
    payload: disease,
  });
};

export const set_licensing = (dispatch, licensing) => {
  return dispatch({
    type: "SET_LICENSING",
    payload: licensing,
  });
};

export const set_status = (dispatch, status) => {
  return dispatch({
    type: "SET_STATUS",
    payload: status,
  });
};

export const set_filters_display = (dispatch, status) => {
    return dispatch({
      type: "SET_FILTERS_DISPLAY",
      payload: status,
    });
  };

export const set_per_page = (dispatch, status) => {
  return dispatch({
    type: "SET_PER_PAGE",
    payload: status,
  });
};

export const set_start_page = (dispatch, status) => {
  return dispatch({
    type: "SET_START_PAGE",
    payload: status,
  });
};


export const fetchPOCData = (dispatch, filters) => {
  if (!filters.offset) {
    filters.offset = 0;
  }

  if (!filters.size) {
    filters.size = 18;
  }

  if (!filters.query) {
    filters.query = "";
  } else {
    filters.query = encodeURIComponent(filters.query);
  }

  if (filters.program) {
    filters.program = encodeURIComponent(filters.program);
  } else {
    filters.program = "";
  }

  if (filters.center_hub) {
    filters.center_hub = encodeURIComponent(filters.center_hub);
  } else {
    filters.center_hub = "";
  }
  if (filters.institutions) {
    filters.institutions = encodeURIComponent(filters.institutions);
  } else {
    filters.institutions = "";
  }
  if (filters.technology) {
    filters.technology = encodeURIComponent(filters.technology);
  } else {
    filters.technology = "";
  }

  if (filters.disease) {
    filters.disease = encodeURIComponent(filters.disease);
  } else {
    filters.disease = "";
  }

  if (filters.licensing) {
    filters.licensing = encodeURIComponent(filters.licensing);
  } else {
    filters.licensing = "";
  }
  if (filters.status) {
    filters.status = encodeURIComponent(filters.status);
  } else {
    filters.status = "";
  }

  if (!filters.sort_field) {
    filters.sort_field = ""
  } 

  if (!filters.sort_type) {
    filters.sort_type = "asc"
  } 

  let url = `?query=${filters.query}&program=${filters.program}&center_hub=${filters.center_hub}&institutions=${filters.institutions}&technology=${filters.technology}&disease=${filters.disease}&licensing=${filters.licensing}&status=${filters.status}&offset=${filters.offset}&sort_type=${filters.sort_type}&sort_field=${filters.sort_field}&size=${filters.size}`;

  axios.get(`${server}/data${url}`).then(function (response) {
    return dispatch({
      type: "FETCH_RESULTS",
      payload: response.data.hits,
    });
  });
};

export const fetchPOCAggs = (dispatch, filters) => {
  if (!filters.query) {
    filters.query = "";
  } else {
    filters.query = encodeURIComponent(filters.query);
  }

  if (filters.program) {
    filters.program = encodeURIComponent(filters.program);
  } else {
    filters.program = "";
  }

  if (filters.center_hub) {
    filters.center_hub = encodeURIComponent(filters.center_hub);
  } else {
    filters.center_hub = "";
  }
  if (filters.institutions) {
    filters.institutions = encodeURIComponent(filters.institutions);
  } else {
    filters.institutions = "";
  }
  if (filters.technology) {
    filters.technology = encodeURIComponent(filters.technology);
  } else {
    filters.technology = "";
  }

  if (filters.disease) {
    filters.disease = encodeURIComponent(filters.disease);
  } else {
    filters.disease = "";
  }

  if (filters.licensing) {
    filters.licensing = encodeURIComponent(filters.licensing);
  } else {
    filters.licensing = "";
  }
  if (filters.status) {
    filters.status = encodeURIComponent(filters.status);
  } else {
    filters.status = "";
  }

  let url = `?query=${filters.query}&program=${filters.program}&center_hub=${filters.center_hub}&institutions=${filters.institutions}&technology=${filters.technology}&disease=${filters.disease}&licensing=${filters.licensing}&status=${filters.status}`;

  axios.get(`${server}/aggs${url}`).then(function (response) {
    return dispatch({
      type: "FETCH_AGGS",
      payload: response.data.aggregations,
    });
  });
};
